
import { upDictItem, addDictItem } from "@/api/api-basic";
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import regular from "@/common/regular";
import i18n from "@/config/i18n";
@Component
export default class SystemConfigUserAdd extends Vue {
  @Prop({ default: "" })
  private typePkId!: string;
  private modalShow = false;
  private loading = true;

  private FormData: objAny = {};
  private modalTitle = i18n.t("dictionary.add");

  private ruleInline: objAny = {
    itemValue: [
      {
        required: true,
        validator: regular.name,
        name: i18n.t("dictionary.itemValue"),
        max: 50,
        trigger: "blur"
      }
    ],
    englishName: [
      {
        required: true,
        validator: regular.name,
        name: i18n.t("dictionary.englishName"),
        max: 150,
        trigger: "blur"
      }
    ],
    thName: [
      {
        required: true,
        validator: regular.name,
        name: i18n.t("dictionary.thName"),
        max: 150,
        trigger: "blur"
      }
    ],
    itemKey: [
      {
        required: true,
        message: i18n.t("dictionary.itemKeyPl"),
        trigger: "blur"
      }
    ]
  };
  private formItem: objAny = {
    flag: 1,
    remark: "",
    itemKey: "",
    itemValue: "",
    orders: 0,
    typePkId: 0,
    pkid: "",
    englishName: "",
    thName: ""
  };
  private flagList: objAny = {
    "0": i18n.t("dictionary.normal"),
    "1": i18n.t("dictionary.disable")
  };
  private isAdd = false;
  public open(item?: objAny) {
    if (!this.FormData.$el) {
      this.$nextTick((): void => {
        this.FormData = this.$refs["formItem"];
      });
    } else {
      this.handleReset();
    }

    this.modalShow = true;
    if (!item) {
      this.formItem.orders = "";
      this.formItem.remark = "";
      this.formItem.itemValue = "";
      this.formItem.englishName = "";
      this.formItem.thName = "";
      this.formItem.typePkId = this.typePkId;
      this.formItem.flag = "0";
      this.modalTitle = i18n.t("dictionary.add");
      this.isAdd = true;
    } else {
      this.formItem.orders = item.orders;
      this.formItem.remark = item.remark;
      this.formItem.itemValue = item.itemValue;
      this.formItem.pkid = item.pkid;
      this.formItem.itemKey = item.itemKey;
      this.formItem.englishName = item.englishName;
      this.formItem.thName = item.thName;
      this.formItem.flag = item.flag + "";
      this.modalTitle = i18n.t("dictionary.updata");
      this.isAdd = false;
    }
  }
  public handleSubmit(): void {
    this.loading = true;

    this.FormData.validate((valid: boolean) => {
      if (valid) {
        this.submitData();
      } else {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
      }
    });
  }
  public closeModal(): void {
    this.modalShow = false;
  }
  public handleReset() {
    this.FormData.resetFields();
  }
  async submitData(): Promise<void> {
    this.formItem.flag = parseInt(this.formItem.flag);
    let ret: objAny;
    if (this.isAdd) {
      ret = await addDictItem(this.formItem);
    } else {
      ret = await upDictItem(this.formItem);
    }
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("deleteSuccess"));
      this.$emit("success");
      this.modalShow = false;
    }
    this.loading = false;
  }
}
